import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAWvoJmQLOQc9PJBMRg2rGaaT7dJGFY6OA",
  authDomain: "echoes-of-engines.firebaseapp.com",
  projectId: "echoes-of-engines",
  messagingSenderId: "384632749434",
  storageBucket: "echoes-of-engines.firebasestorage.app",
  appId: "1:384632749434:web:b7e4f3abcfab82fc97aac3"
};

export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
